import React from "react";
import { Alert, Typography } from "antd";

import { Modal } from "@components/Page";
import { W0, W1 } from "@components/Constants";

const LABEL_TITLE = "Public Key Added";
const LABEL_INFO = "Give both values to your client";
const LABEL_INFO_DESCRIPTION = "Your client signs each ID token with the private key. The kid header of the token must be this key ID, and the iss claim must be this issuer.";
const LABEL_KEY_ID = "Key ID (kid header)";
const LABEL_ISSUER = "Issuer (iss claim)";

type Props = {
  name?: string;
  issuer?: string;
  publicKeyId?: string;
  isOpen: boolean;
  onClose: () => void;
};

const OrganizationPublicKeyCreatedModal = ({
  name,
  issuer,
  publicKeyId,
  isOpen,
  onClose,
}: Props): JSX.Element => {
  const modalProps = {
    title: LABEL_TITLE,
    isOpen,
    onClose,
  };

  const labelStyle = {
    marginBottom: W0 / 2,
  };

  const valueStyle = {
    marginBottom: W1,
    wordBreak: "break-all" as const,
  };

  return (
    <Modal {...modalProps}>
      <Alert
        showIcon
        type="info"
        message={LABEL_INFO}
        description={LABEL_INFO_DESCRIPTION}
        style={{ marginBottom: W1 }}
      />

      <Typography.Paragraph strong style={{ marginBottom: W1 }}>
        {name}
      </Typography.Paragraph>

      <Typography.Paragraph type="secondary" style={labelStyle}>
        {LABEL_KEY_ID}
      </Typography.Paragraph>

      <Typography.Paragraph
        code
        copyable={{ text: publicKeyId }}
        style={valueStyle}
      >
        {publicKeyId}
      </Typography.Paragraph>

      <Typography.Paragraph type="secondary" style={labelStyle}>
        {LABEL_ISSUER}
      </Typography.Paragraph>

      <Typography.Paragraph
        code
        copyable={{ text: issuer }}
        style={valueStyle}
      >
        {issuer}
      </Typography.Paragraph>
    </Modal>
  );
};

export default OrganizationPublicKeyCreatedModal;
